import React, { useState, useEffect, useCallback } from "react";
import { Box, Paper, Typography, Button, CircularProgress } from "@material-ui/core";
import EventIcon from "@material-ui/icons/Event";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { toast } from "react-toastify";
import api from "../../services/api";

// Conexao do Google Calendar - uma agenda unica e compartilhada pra
// empresa toda (ver GoogleCalendarAuthService.ts no backend), nao uma
// conta por usuario. Callback do Google redireciona de volta pra essa
// tela com ?googleCalendar=connected|error na URL.
const GoogleCalendarCard = () => {
  const [loading, setLoading] = useState(true);
  const [connecting, setConnecting] = useState(false);
  const [status, setStatus] = useState({ connected: false, connectedEmail: null });

  const fetchStatus = useCallback(async () => {
    try {
      const { data } = await api.get("/google-calendar/status");
      setStatus(data);
    } catch (err) {
      console.error("Falha ao consultar status do Google Calendar:", err);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const result = params.get("googleCalendar");
    if (result === "connected") {
      toast.success("Google Calendar conectado com sucesso!");
      window.history.replaceState({}, "", window.location.pathname);
    } else if (result === "error") {
      toast.error("Não foi possível conectar ao Google Calendar. Tente novamente.");
      window.history.replaceState({}, "", window.location.pathname);
    }
    fetchStatus();
  }, [fetchStatus]);

  const handleConnect = async () => {
    setConnecting(true);
    try {
      const { data } = await api.get("/google-calendar/auth-url");
      window.location.href = data.url;
    } catch (err) {
      toast.error("Falha ao iniciar conexão com o Google Calendar.");
      setConnecting(false);
    }
  };

  const handleDisconnect = async () => {
    setConnecting(true);
    try {
      await api.post("/google-calendar/disconnect");
      toast.success("Google Calendar desconectado.");
      await fetchStatus();
    } catch (err) {
      toast.error("Falha ao desconectar o Google Calendar.");
    }
    setConnecting(false);
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  return (
    <Paper variant="outlined" style={{ padding: 24, maxWidth: 520 }}>
      <Box style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
        <EventIcon color="action" />
        <Typography variant="h6">Google Calendar</Typography>
      </Box>
      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
        Conecta a agenda da empresa (uma única, compartilhada entre setores e atendentes) com o
        Google Calendar. Agendamentos criados a partir de um ticket ou do Kanban são
        automaticamente sincronizados.
      </Typography>

      {status.connected ? (
        <>
          <Box style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
            <CheckCircleIcon style={{ color: "#22c55e" }} fontSize="small" />
            <Typography variant="body2">
              Conectado como <strong>{status.connectedEmail}</strong>
            </Typography>
          </Box>
          <Button variant="outlined" color="secondary" disabled={connecting} onClick={handleDisconnect}>
            Desconectar
          </Button>
        </>
      ) : (
        <Button variant="contained" color="primary" disabled={connecting} onClick={handleConnect}>
          Conectar com Google Calendar
        </Button>
      )}
    </Paper>
  );
};

export default GoogleCalendarCard;
